import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { SonarCard } from '@ui/general';
export const AccessComparison = () => React.createElement(SonarCard, { title: COPY_SPECIFIC.ACCESS_COMPARISON });
